<template>
  <div class="nav zhzw-modulesNav"
    @mouseleave="ulLeave">
    <!-- 九大模块导航 -->
    <ul class="main-nav">
      <li v-for="(item, key) in menu"
        :key="key"
        class="font-main"
        :class="{'active': item.id === activeName}"
        @mouseenter="liEnter(item.id)"
        @click="liClick(item)">
        {{item.serverName}}
        <i v-if="item.children && item.children.length > 0"
          class="el-icon-arrow-right"></i>
      </li>
    </ul>
    <!-- 向下一级和二级展开导航 -->
    <transition name="fade">
      <ul v-if="showMoreNav && moreNav.length > 0"
        class="more-nav">
        <li v-for="(item, key) in moreNav"
          :key="key">
          <p>{{item.label}}</p>
          <span v-for="(child, index) in item.children"
            :key="index">{{child.label}}</span>
        </li>
      </ul>
    </transition>
  </div>
</template>
<script>
export default {
  name: "modulesNav",
  props: {
    menu: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      moreNav: [],
      showMoreNav: false,
      activeName: ""
    };
  },
  methods: {
    // 进入ul内的li范围就展开更多导航
    liEnter(id) {
      let activeLi = this.menu.find(elem => {
        return elem.id === id;
      });
      this.moreNav = activeLi.children || [];
      this.showMoreNav = true;
      this.activeName = id;
    },
    // 只有完全离开ul范围时才收起更多导航
    ulLeave(id) {
      this.showMoreNav = false;
      this.activeName = "";
    },
    liClick(item) {
      // window.location.href = item.url
      switch (item.target) {
        case '_blank':
          let downloadWidnow = window.open()
          downloadWidnow.location.href = item.url
          break;
        case '_self':
          window.location.href = item.url
          break;
        default:
          {
            let downloadWidnow = window.open()
            downloadWidnow.location.href = item.url
          }
          break;
      }
    }
  }
};
</script>
<style lang="scss">
.zhzw-modulesNav {
  &.nav {
    height: calc(100% - 104px);
    position: absolute;
    z-index: 100;
    top: 104px;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
  }
  .main-nav {
    height: 100%;
    width: 200px;
    color: #fff;
    background-color: #323e4d;
    float: left;
    padding-top: 30px;
    li {
      line-height: 48px;
      padding: 0 24px 0 20px;
      > i {
        float: right;
        line-height: 48px;
      }
    }
    li.active {
      background-color: $--color-primary;
    }
  }
  .more-nav {
    height: 100%;
    z-index: 10;
    background-color: #fff;
    display: inline-block;
    position: relative;
    &::before {
      display: block;
      content: "";
      position: absolute;
      width: calc(100% - 20px);
      height: 1px;
      top: 75px;
      left: 20px;
      background-color: $color-border;
    }
    li {
      width: 155px;
      height: 100%;
      float: left;
      padding: 35px 15px 0 10px;
      p {
        line-height: 40px;
        padding-left: 10px;
        margin-bottom: 10px;
      }
      span {
        display: block;
        width: 100%;
        line-height: 30px;
        color: $color-font-normal;
        padding-left: 10px;
        &:hover {
          background-color: $color-background;
          color: $--color-primary;
        }
      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>


// WEBPACK FOOTER //
// ../vue-common-laboratory/src/components/common/ModulesNav.vue